import { render, staticRenderFns } from "./ModulePassport.vue?vue&type=template&id=0fb0c85c&"
import script from "./ModulePassport.vue?vue&type=script&lang=js&"
export * from "./ModulePassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports